import { motion } from "framer-motion";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import eventsLottie from "../assets/lottie-files/events.lottie";
import EventGrid from "../components/events/EventsGrid";

// Uncomment when Mailchimp URL is ready:
// import { useState, useRef } from "react";
// const MAILCHIMP_EVENTS_URL = "REPLACE_WITH_YOUR_MAILCHIMP_EVENT_ALERTS_FORM_ACTION_URL";
// declare global { interface Window { _mcEventsCallback?: (data: { result: string; msg: string }) => void; } }
// type Status = "idle" | "submitting" | "success" | "error";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" as const },
  },
};
const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};

declare global {
  interface Window {
    _mcEventsCallback?: (data: { result: string; msg: string }) => void;
  }
}

// type Status = "idle" | "submitting" | "success" | "error";

export default function EventsPage() {
  // Uncomment when Mailchimp URL is ready:
  // const [email, setEmail] = useState("");
  // const [status, setStatus] = useState<Status>("idle");
  // const [errorMsg, setErrorMsg] = useState("");
  // const scriptRef = useRef<HTMLScriptElement | null>(null);
  // const handleSubscribe = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (!email || status === "submitting") return;
  //   setStatus("submitting"); setErrorMsg("");
  //   const callbackName = "_mcEventsCallback";
  //   window[callbackName] = (data) => {
  //     if (scriptRef.current) document.body.removeChild(scriptRef.current);
  //     scriptRef.current = null; delete window[callbackName];
  //     if (data.result === "success") { setStatus("success"); setEmail(""); }
  //     else { setStatus("error"); setErrorMsg(data.msg.replace(/<[^>]+>/g, "")); }
  //   };
  //   const url = MAILCHIMP_EVENTS_URL.replace("/post?", "/post-json?") + `&EMAIL=${encodeURIComponent(email)}&c=${callbackName}`;
  //   const script = document.createElement("script");
  //   script.src = url;
  //   script.onerror = () => { if (scriptRef.current) document.body.removeChild(scriptRef.current); scriptRef.current = null; delete window[callbackName]; setStatus("error"); setErrorMsg("Something went wrong. Please try again."); };
  //   scriptRef.current = script; document.body.appendChild(script);
  // };

  return (
    <div>
      {/* ── HERO ── */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #0a2605 0%, #0d1b2a 55%, #150308 100%)",
          padding: "5rem 1.5rem 6rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -120,
            right: -120,
            width: 440,
            height: 440,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(198,37,45,0.2) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -100,
            left: -100,
            width: 380,
            height: 380,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(109,199,68,0.15) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "3rem",
            position: "relative",
            zIndex: 1,
          }}
        >
          <motion.div
            style={{ flex: "1 1 480px", minWidth: 300 }}
            variants={stagger}
            initial="hidden"
            animate="visible"
          >
            <motion.span
              variants={fadeUp}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "rgba(109,199,68,0.12)",
                border: "1px solid rgba(109,199,68,0.3)",
                borderRadius: 999,
                padding: "0.35rem 1rem",
                color: "#6dc744",
                fontSize: "0.82rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "1rem",
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  background: "#6dc744",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              />
              What's On
            </motion.span>

            <motion.h1
              variants={fadeUp}
              style={{
                fontSize: "clamp(2.4rem, 5.5vw, 4rem)",
                fontWeight: 900,
                color: "white",
                lineHeight: 1.08,
                marginBottom: "1.25rem",
              }}
            >
              Upcoming{" "}
              <span
                style={{
                  background: "linear-gradient(90deg, #6dc744, #c6252d)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Events
              </span>
            </motion.h1>

            <motion.p
              variants={fadeUp}
              style={{
                fontSize: "1.15rem",
                color: "rgba(255,255,255,0.72)",
                lineHeight: 1.7,
                marginBottom: "2rem",
                maxWidth: 520,
              }}
            >
              Discover the vibrant events happening at the St. John's Farmers'
              Market — from craft fairs and live music to workshops and
              community gatherings. There's always something on.
            </motion.p>

            <motion.div variants={fadeUp} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
              <a
                href="#events"
                style={{ display: "inline-block", background: "linear-gradient(135deg, #c6252d, #a01e25)", color: "white", borderRadius: 999, padding: "0.9rem 2.2rem", fontWeight: 700, fontSize: "1rem", cursor: "pointer", textDecoration: "none", boxShadow: "0 4px 20px rgba(198,37,45,0.35)", transition: "transform 0.2s, box-shadow 0.2s", alignSelf: "flex-start" }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(198,37,45,0.5)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(198,37,45,0.35)"; }}
              >
                Browse Events →
              </a>

              {/* ── inline signup (commented out until Mailchimp URL is configured) ── */}
              {/* <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.12)" }} />
                <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.8rem", whiteSpace: "nowrap" }}>or get notified of new events</span>
                <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.12)" }} />
              </div>

              {status === "success" ? (
                <div style={{ display: "inline-flex", alignItems: "center", gap: "0.6rem", background: "rgba(109,199,68,0.12)", border: "1px solid rgba(109,199,68,0.35)", borderRadius: 999, padding: "0.7rem 1.25rem" }}>
                  <span>🎉</span>
                  <span style={{ color: "#6dc744", fontWeight: 700, fontSize: "0.95rem" }}>You're signed up! We'll email you when events are posted.</span>
                </div>
              ) : (
                <form onSubmit={handleSubscribe} style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap", maxWidth: 520 }}>
                  <input
                    type="email"
                    required
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
                    style={{ flex: "1 1 200px", padding: "0.8rem 1.25rem", borderRadius: 999, border: "1px solid rgba(109,199,68,0.3)", background: "rgba(255,255,255,0.07)", color: "white", fontSize: "0.95rem", outline: "none", backdropFilter: "blur(6px)" }}
                    onFocus={(e) => { e.currentTarget.style.border = "1px solid rgba(109,199,68,0.7)"; e.currentTarget.style.background = "rgba(255,255,255,0.1)"; }}
                    onBlur={(e) => { e.currentTarget.style.border = "1px solid rgba(109,199,68,0.3)"; e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
                  />
                  <button
                    type="submit"
                    disabled={status === "submitting"}
                    style={{ padding: "0.8rem 1.5rem", borderRadius: 999, border: "1px solid rgba(109,199,68,0.4)", background: "transparent", color: "#6dc744", fontWeight: 700, fontSize: "0.95rem", cursor: status === "submitting" ? "not-allowed" : "pointer", whiteSpace: "nowrap", transition: "all 0.2s", opacity: status === "submitting" ? 0.7 : 1 }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(109,199,68,0.15)"; e.currentTarget.style.borderColor = "rgba(109,199,68,0.7)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = "rgba(109,199,68,0.4)"; }}
                  >
                    {status === "submitting" ? "Signing up…" : "Notify Me"}
                  </button>
                  {status === "error" && (
                    <p style={{ color: "#f87171", fontSize: "0.85rem", margin: "0.25rem 0 0 0.5rem", width: "100%" }}>
                      {errorMsg || "Something went wrong. Please try again."}
                    </p>
                  )}
                </form>
              )} */}
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.88 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.85, ease: "easeOut" }}
            style={{
              flex: "1 1 360px",
              minWidth: 280,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <DotLottieReact
              src={eventsLottie}
              loop
              autoplay
              style={{ width: "100%", maxWidth: 440 }}
            />
          </motion.div>
        </div>
      </section>

      {/* ── EVENT GRID ── */}
      <section
        id="events"
        style={{ background: "#fffdf8", padding: "4rem 1.5rem" }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <EventGrid showFilters sort="asc" />
        </div>
      </section>
    </div>
  );
}
